/* eslint-disable no-nested-ternary */
import React from 'react';
import { Breadcrumbs, Grid, Link, makeStyles, Typography } from '@material-ui/core/';
import { Route } from 'react-router-dom';
import { NavLink as RouterLink } from 'react-router-dom';
import { breadcrumbNameMap } from '../../Constants/BreadCrumbs';
import { Search_Root_NavLink_To, Results_NavLink_To } from '../../Constants/AppBar';
import { useStore } from 'react-redux';

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const useStyles = makeStyles((theme) => ({
	breadcrumbs: { height: theme.spacing(8) },
}));

// Rendering last active breadcrumb.
const RenderLastActiveBreadCrumb = ({ to }) => {
	const store = useStore();
	const breadCrumbDisplayLabel = breadcrumbNameMap[to];
	// Appending search term from redux store for the results search bread crumb.
	// so that user can navigate to results search from back to manage asset / manage products page.
	if (to === Results_NavLink_To) {
		to = to + '/' + store.getState().resultsSearchTerm;
	}
	return (
		<LinkRouter color="inherit" to={to} key={to}>
			<Typography color="primary" variant="body2">
				{breadCrumbDisplayLabel}
			</Typography>
		</LinkRouter>
	);
};
function RouterBreadcrumbs() {
	// Mapping breadcrumbs names to appropriate routes using location.pathname prop.
	// breadcrumb for Default loading page is always "/Search"
	// integrating Material UI breadcrumb components with react router
	const classes = useStyles();
	return (
		<Grid container item className={classes.breadcrumbs}>
			<Route>
				{({ location, match, history }) => {
					//for the default loading which is Search component
					if (location.pathname === Search_Root_NavLink_To) {
						return (
							<Grid item xs={11}>
								<Breadcrumbs aria-label="breadcrumb">
									<Typography color="textPrimary" variant="body2" key={'/Search'}>
										{breadcrumbNameMap[location.pathname]}
									</Typography>
								</Breadcrumbs>
							</Grid>
						);
					} else {
						// Splitting pathname's basing on "/" to build the bread crumb for the child routes and components
						let pathNames = match.path.split('/').filter((x) => x);
						// removing the params from path names to construct bread crumbs
						pathNames = pathNames.filter((x) => !x.includes(':'));
						return (
							<Grid container item>
								<Grid item xs={11}>
									<Breadcrumbs aria-label="breadcrumb">
										{pathNames.map((value, index) => {
											const last = index === pathNames.length - 1;
											const to = `/${pathNames.slice(0, index + 1).join('/')}`;
											// The last breadcrumb should always be active with primary color precedence.
											return last ? (
												<Typography color="textPrimary" variant="body2" key={to}>
													{breadcrumbNameMap[to]}
												</Typography>
											) : (
												<RenderLastActiveBreadCrumb key={to} to={to} />
											);
										})}
									</Breadcrumbs>
								</Grid>
							</Grid>
						);
					}
				}}
			</Route>
		</Grid>
	);
}

export default RouterBreadcrumbs;
